<template>
  <div style="position: relative;">
    <iframe
      v-if="version !== ''"
      id="baidutongji"
      name="baidutongji"
      :src="`https://aiplugin.5118.com/Pluginstat/?p=SEOINFO&v=${version}`"
      style="
        width: 0px;
        height: 0px;
        position: fixed;
        transform: translateY(-9999px);
      "
    ></iframe>
    <div dir="rtl" class="page">
      <div dir="ltr">
        <p class="checkdomainname" :title="getdomain">
          当前域名【{{ getdomain }}】
        </p>
        <div style="margin-bottom: 5px;">
          <ul>
            <li @click="isCheck = true" :class="{ active: isCheck }">
              域名权重
            </li>
            <li @click="isCheck = false" :class="{ active: !isCheck }">
              整域权重
            </li>
          </ul>
        </div>
        <table class="table" v-if="!Object.isEmptyObject(chart)">
          <thead>
            <tr>
              <th>引擎</th>
              <th v-if="isCheck">5118权重</th>
              <th v-if="!isCheck">整域<br />5118权重</th>
              <th v-if="isCheck">受宠排名</th>
              <th v-if="!isCheck">整域<br />受宠排名</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                百度PC
              </td>
              <template v-if="isCheck">
                <td>
                  <a
                    class="baidu-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.BaiduPC.weight }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.BaiduPC.favour }}
                    <template
                      v-if="
                        chart.BaiduPC.favourUpDown !== 0 &&
                        chart.BaiduPC.favourUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.BaiduPC.favourUpDown != 0"
                        :src="
                          chart.BaiduPC.favourUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.BaiduPC.favourUpDown != 0"
                        :style="{
                          color:
                            chart.BaiduPC.favourUpDown > 0 ? `red` : `green`,
                        }"
                        >{{ Math.abs(chart.BaiduPC.favourUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
              <template v-else>
                <td>
                  <a
                    class="baidu-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.BaiduPC.Weight_Domain }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.BaiduPC.FavourRank_Domain }}
                    <template
                      v-if="
                        chart.BaiduPC.FavourRank_DomainUpDown !== 0 &&
                        chart.BaiduPC.FavourRank_DomainUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.BaiduPC.FavourRank_DomainUpDown != 0"
                        :src="
                          chart.BaiduPC.FavourRank_DomainUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.BaiduPC.FavourRank_DomainUpDown != 0"
                        :style="{
                          color:
                            chart.BaiduPC.FavourRank_DomainUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{
                          Math.abs(chart.BaiduPC.FavourRank_DomainUpDown)
                        }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                百度移动
              </td>
              <template v-if="isCheck">
                <td>
                  <a
                    class="baidu-mobile-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.BaiduMobile.weight }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.BaiduMobile.favour }}
                    <template
                      v-if="
                        chart.BaiduMobile.favourUpDown !== 0 &&
                        chart.BaiduMobile.favourUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.BaiduMobile.favourUpDown != 0"
                        :src="
                          chart.BaiduMobile.favourUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.BaiduMobile.favourUpDown != 0"
                        :style="{
                          color:
                            chart.BaiduMobile.favourUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{ Math.abs(chart.BaiduMobile.favourUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
              <template v-else>
                <td>
                  <a
                    class="baidu-mobile-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.BaiduMobile.Weight_Domain }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.BaiduMobile.FavourRank_Domain }}
                    <template
                      v-if="
                        chart.BaiduMobile.FavourRank_DomainUpDown !== 0 &&
                        chart.BaiduMobile.FavourRank_DomainUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.BaiduMobile.FavourRank_DomainUpDown != 0"
                        :src="
                          chart.BaiduMobile.FavourRank_DomainUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.BaiduMobile.FavourRank_DomainUpDown != 0"
                        :style="{
                          color:
                            chart.BaiduMobile.FavourRank_DomainUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{
                          Math.abs(chart.BaiduMobile.FavourRank_DomainUpDown)
                        }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                360好搜
              </td>
              <template v-if="isCheck">
                <td>
                  <a
                    class="haosou-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.HaoSou.weight }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.HaoSou.favour }}
                    <template
                      v-if="
                        chart.HaoSou.favourUpDown !== 0 &&
                        chart.HaoSou.favourUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.HaoSou.favourUpDown != 0"
                        :src="
                          chart.HaoSou.favourUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.HaoSou.favourUpDown != 0"
                        :style="{
                          color:
                            chart.HaoSou.favourUpDown > 0 ? `red` : `green`,
                        }"
                        >{{ Math.abs(chart.HaoSou.favourUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
              <template v-else>
                <td>
                  <a
                    class="haosou-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.HaoSou.Weight_Domain }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.HaoSou.FavourRank_Domain }}
                    <template
                      v-if="
                        chart.HaoSou.FavourRank_DomainUpDown !== 0 &&
                        chart.HaoSou.FavourRank_DomainUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.HaoSou.FavourRank_DomainUpDown != 0"
                        :src="
                          chart.HaoSou.FavourRank_DomainUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.HaoSou.FavourRank_DomainUpDown != 0"
                        :style="{
                          color:
                            chart.HaoSou.FavourRank_DomainUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{
                          Math.abs(chart.HaoSou.FavourRank_DomainUpDown)
                        }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                神马搜索
              </td>
              <template v-if="isCheck">
                <td>
                  <a
                    class="shenma-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.Sm.weight }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.Sm.favour }}
                    <template
                      v-if="
                        chart.Sm.favourUpDown !== 0 &&
                        chart.Sm.favourUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.Sm.favourUpDown != 0"
                        :src="
                          chart.Sm.favourUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.Sm.favourUpDown != 0"
                        :style="{
                          color: chart.Sm.favourUpDown > 0 ? `red` : `green`,
                        }"
                        >{{ Math.abs(chart.Sm.favourUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
              <template v-else>
                <td>
                  <a
                    class="shenma-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{ chart.Sm.Weight_Domain }}</span>
                  </a>
                </td>
                <td>
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{ chart.Sm.FavourRank_Domain }}
                    <template
                      v-if="
                        chart.Sm.FavourRank_DomainUpDown !== 0 &&
                        chart.Sm.FavourRank_DomainUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.Sm.FavourRank_DomainUpDown != 0"
                        :src="
                          chart.Sm.FavourRank_DomainUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.Sm.FavourRank_DomainUpDown != 0"
                        :style="{
                          color:
                            chart.Sm.FavourRank_DomainUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{ Math.abs(chart.Sm.FavourRank_DomainUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                头条
              </td>
              <template v-if="isCheck">
                <td>
                  <a
                    class="toutiao-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{
                      chart.Toutiao && chart.Toutiao != null
                        ? chart.Toutiao.weight
                        : 0
                    }}</span>
                  </a>
                </td>
                <td v-if="chart.Toutiao && chart.Toutiao != null">
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{
                      chart.Toutiao && chart.Toutiao != null
                        ? chart.Toutiao.favour
                        : 0
                    }}
                    <template
                      v-if="
                        chart.Toutiao.favourUpDown !== 0 &&
                        chart.Toutiao.favourUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.Toutiao.favourUpDown != 0"
                        :src="
                          chart.Toutiao.favourUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.Toutiao.favourUpDown != 0"
                        :style="{
                          color:
                            chart.Toutiao.favourUpDown > 0 ? `red` : `green`,
                        }"
                        >{{ Math.abs(chart.Toutiao.favourUpDown) }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
              <template v-else>
                <td>
                  <a
                    class="toutiao-weight"
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    target="_blank"
                  >
                    <span>{{
                      chart.Toutiao && chart.Toutiao != null
                        ? chart.Toutiao.Weight_Domain
                        : 0
                    }}</span>
                  </a>
                </td>
                <td v-if="chart.Toutiao && chart.Toutiao != null">
                  <a
                    :href="`https://seo.5118.com/${jump_domain_url}?f=plugin`"
                    class="ranking"
                    target="_blank"
                  >
                    {{
                      chart.Toutiao && chart.Toutiao != null
                        ? chart.Toutiao.FavourRank_Domain
                        : 0
                    }}
                    <template
                      v-if="
                        chart.Toutiao.FavourRank_DomainUpDown !== 0 &&
                        chart.Toutiao.FavourRank_DomainUpDown !== '-'
                      "
                    >
                      <br />
                      <img
                        v-if="chart.Toutiao.FavourRank_DomainUpDown != 0"
                        :src="
                          chart.Toutiao.FavourRank_DomainUpDown > 0
                            ? require('../assets/image/down.png')
                            : require('../assets/image/up.png')
                        "
                      />
                      <span
                        v-if="chart.Toutiao.FavourRank_DomainUpDown != 0"
                        :style="{
                          color:
                            chart.Toutiao.FavourRank_DomainUpDown > 0
                              ? `red`
                              : `green`,
                        }"
                        >{{
                          Math.abs(chart.Toutiao.FavourRank_DomainUpDown)
                        }}</span
                      >
                    </template>
                  </a>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
        <br />
        <div
          id="_5118_Add_Logo"
          style="margin-top: -10px; margin-left: -1px;"
          v-html="adinfo"
        ></div>
        <br /><br /><br />
        <v-chart
          title="百度PC排名趋势▼"
          :data="getChartData(false, 'BaiduPC', 'baiduPCChart')"
          id="biadu-pc"
          :rankallcount="getrankcount('BaiduPC', 'baiduPCRowCount')"
        ></v-chart>
        <br />
        <v-chart
          title="百度移动排名趋势▼"
          :data="getChartData(true, 'BaiduMobile', 'baiduMobileChart')"
          id="biadu-mobile"
          :rankallcount="getrankcount('BaiduMobile', 'baiduMobileRowCount')"
        ></v-chart>
        <br />
        <v-chart
          title="360排名趋势▼"
          :data="getChartData(false, 'HaoSou', 'haosouChart')"
          id="haosou"
          :rankallcount="getrankcount('HaoSou', 'haosouRowCount')"
        ></v-chart>
        <br />
        <v-chart
          title="神马排名趋势▼"
          :data="getChartData(false, 'Sm', 'smChart')"
          id="shenma"
          :rankallcount="getrankcount('Sm', 'smRowCount')"
        ></v-chart>
        <br />
        <v-chart
          v-if="chart.Toutiao && chart.Toutiao != null"
          title="头条排名趋势▼"
          :data="getChartData(false, 'Toutiao', 'toutiaoChart')"
          id="toutiao"
          :rankallcount="getrankcount('Toutiao', 'toutiaoRowCount')"
        ></v-chart>
        <br />
        <div class="source">
          <div style="padding-bottom: 10px;">
            <p class="title">百度来路</p>
            <div class="card">{{ aizhan.baidurank_ip }}IP</div>
          </div>
          <div style="padding-bottom: 10px;">
            <p class="title">移动来路</p>
            <div class="card">{{ aizhan.baidurank_m_ip }}IP</div>
          </div>
          <div style="padding-bottom: 10px; font-size: 12px;">
            预估日均IP≈
            <strong style="vertical-align: top;">
              {{ aizhan.alexa_ip || '暂无数据' }}</strong
            >
          </div>
          <div style="font-size: 12px;">
            预估日均PV≈
            <strong style="vertical-align: top;">{{
              aizhan.alexa_pv || '暂无数据'
            }}</strong>
          </div>
        </div>
        <div class="aizhan row">
          <div class="col-15">
            <p class="title">出站链接</p>
            <p class="desc">{{ aizhan.webpage_link_o }}</p>
          </div>
          <div class="col-15">
            <p class="title">首页内链</p>
            <p class="desc">{{ aizhan.webpage_link_i }}</p>
          </div>
          <div class="col-15">
            <p class="title">爱站百度权重</p>
            <p class="desc" v-html="aizhan.baidurank_br"></p>
          </div>
          <div class="col-15">
            <p class="title">爱站移动权重</p>
            <p class="desc" v-html="aizhan.baidurank_mbr"></p>
          </div>
          <div class="col-15">
            <p class="title">搜狗PR</p>
            <p class="desc" v-html="aizhan.sogou_pr"></p>
          </div>
          <div class="col-15">
            <p class="title">谷歌PR</p>
            <p class="desc" v-html="aizhan.google_pr"></p>
          </div>
          <div class="col-15">
            <p class="title">反链</p>
            <p class="desc">{{ aizhan.backlink }}</p>
          </div>
          <div class="col-15">
            <p class="title">世界排名</p>
            <p class="desc">{{ aizhan.alexa_rank }}</p>
          </div>
        </div>
        <div class="age" v-if="aizhan.whois_created">
          {{ aizhan.whois_created }}
        </div>
        <div class="age" v-if="aizhan.whois_registrant">
          {{ aizhan.whois_registrant }}
        </div>
      </div>
    </div>
    <div class="div-bottom">
      <button
        class="btn btn-bottom"
        onclick="window.open(`https://monitor.5118.com/?f=plugin`)"
      >
        对网站进行SEO监控
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'SeoBigData',
  computed: {
    isCheck: {
      get() {
        return this.$store.state.seoBigData.isCheck;
      },
      set(val) {
        this.$store.state.seoBigData.isCheck = val;
      },
    },
    chart: {
      get() {
        return this.$store.state.seoBigData.chart;
      },
      set(val) {
        this.$store.state.seoBigData.chart = val;
      },
    },
    aizhan: {
      get() {
        return this.$store.state.seoBigData.aizhan;
      },
      set(val) {
        this.$store.state.seoBigData.aizhan = val;
      },
    },
    adinfo: {
      get() {
        return this.$store.state.seoBigData.adinfo;
      },
      set(val) {
        this.$store.state.seoBigData.adinfo = val;
      },
    },
    jump_domain_url: {
      get() {
        return this.$store.state.menu.jump_domain_url;
      },
      set(val) {
        this.$store.state.menu.jump_domain_url = val;
      },
    },
    version: {
      get() {
        return this.$store.state.menu.version;
      },
      set(val) {
        this.$store.state.menu.version = val;
      },
    },
    token: {
      get() {
        return this.$store.state.menu.token;
      },
      set(val) {
        this.$store.state.menu.token = val;
      },
    },
    getdomain: {
      get() {
        return this.$store.state.menu.jump_domain_url;
      },
    },
  },
  mounted() {
    this.ASetHistory('seobigdata').then((flag) => {
      if (flag) {
        if (localStorage.getItem('_5118_Get_Ad_Time')) {
          let datatimeobj = this.localstorageget(
            '_5118_Get_Ad_Time',
            1000 * 60 * 5
          );
          if (datatimeobj !== '' && datatimeobj !== null) {
            this.adinfo = datatimeobj;
          } else {
            this.getAdInfo();
          }
        } else {
          this.getAdInfo();
        }
        this.listenSeoBigData();
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send('Seo-Big-Data', this.token);
      }
    });
  },
  methods: {
    ...mapActions('menu', ['ASetHistory']),
    getChartData(hasKay, type, name) {
      try {
        let chartData = this.chart;
        chartData = this.chart[type][name];
        let _ = eval('(' + chartData + ')');
        if (type === 'HaoSou' || type === 'Sm' || type === 'Toutiao') {
          let c = _[0].result;
          let __ = { Top20: [], Top10: [] };
          let xSeries = [];
          for (let k in c.AvgValue) {
            __.Top10.push(c.Top10[k]);
            __.Top20.push(c.Top20[k]);
            xSeries.push(k);
          }
          __.Top10 = __.Top10.reverse();
          __.Top20 = __.Top20.reverse();

          return { result: __, xSeries: xSeries.reverse() };
        }
        if (type === 'BaiduMobile') {
          _.result = _.result[Object.keys(_.result)[0]];
          return _;
        }
        return _;
      } catch (e) {
        return {};
      }
    },
    async getAdInfo() {
      let datainfo = await axios.get('https://8.5118.com/g/102/511832.html');
      let data = datainfo.data
        .replace('document.write("', '')
        .replace('");', '');
      this.adinfo = data;
      this.localstorageset('_5118_Get_Ad_Time', data);
    },
    getrankcount(type, name) {
      if (this.chart && this.chart[type] && this.chart[type][name] !== null) {
        return this.chart[type][name];
      } else {
        return 0;
      }
    },
    listenSeoBigData() {
      this.$messenger.listen('_5118_SeoBigData', (msg) => {
        this.chart = eval('(' + msg + ')');
        this.jump_domain_url = this.chart.jump_domain_url;
      });
      this.$messenger.listen('_Aizhan_SeoBigData', (msg) => {
        this.aizhan = msg;
      });
      // this.$messenger.listen("_5118_connect_msg_send", (msg) => {

      // });
    },
    //设置localstorage过期时间
    localstorageset(key, value) {
      var curTime = new Date().getTime();
      localStorage.setItem(key, JSON.stringify({ data: value, time: curTime }));
    },
    //获取localstorage过期时间
    localstorageget(key, exp) {
      var data = localStorage.getItem(key);
      var dataObj = JSON.parse(data);
      if (new Date().getTime() - dataObj.time > exp) {
        return null;
      } else {
        var dataObjDatatoJson = dataObj.data;
        return dataObjDatatoJson;
      }
    },
  },
};
</script>

<style type="text/less" lang="less" scoped>
@import '../assets/style/color';
@import '../assets/style/config';
@import '../assets/style/mixin';

ul {
  height: 30px;
  background-color: #ebf2fe;
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px;
}

li {
  cursor: pointer;
  margin-top: 4px;
  width: 50%;
  text-align: center;
  line-height: 25px;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-weight: bold;
}

.active {
  background-color: #fff;
  color: #166df1;
}

.table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  box-shadow: rgb(234, 234, 234) 0 1px 6px 0;
  border: 1px solid rgb(230, 230, 230);
  border-image: initial;
  table-layout: fixed;

  th {
    font-size: 12px;
    line-height: 12px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    background-color: rgb(238, 243, 247);
    color: rgb(58, 79, 112);
    padding: 0;
    border: 1px solid rgb(239, 239, 239);
    border-image: initial;
  }

  td {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    padding: 5px 0;
    border: 1px solid rgb(239, 239, 239);
    border-image: initial;

    span {
      position: relative;
      left: 12px;
      top: 2px;
      font-size: 12px;
    }
  }

  .bg {
    height: 25px;
    width: 70px;
    font-size: 15px;
    color: rgb(255, 255, 255);
    text-align: center;
    margin: 0 auto;
    display: block;
  }

  .baidu-weight {
    .bg();
    background: url('../assets/image/baidupc.png') no-repeat center;
  }

  .baidu-mobile-weight {
    .bg();
    background: url('../assets/image/baidumobile.png') no-repeat center;
  }

  .haosou-weight {
    .bg();
    background: url('../assets/image/360.png') no-repeat center;
  }

  .shenma-weight {
    .bg();
    background: url('../assets/image/shenma.png') no-repeat center;
  }

  .toutiao-weight {
    .bg();
    background: url('../assets/image/toutiao.png') no-repeat center;
  }

  .ranking {
    text-align: center;
    margin: 0 auto;
    display: block;

    .green {
      color: @green;
    }

    .red {
      color: @red;
    }

    span {
      position: static;
    }
  }
}

.source {
  border-bottom: 1px dashed #eee;
  padding-bottom: 20px;

  .title {
    color: #3a4f70;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 3px;
  }

  .card {
    background-color: #e5f6da;
    border-radius: 4px;
    margin-top: 5px;
    color: #0c960c;
    line-height: 30px;
    padding-left: 10px;
    font-size: 12px;
  }
}

.aizhan {
  border-bottom: 1px dashed #eee;
  padding: 10px 0;

  .col-15 {
    margin-bottom: 3px;
  }

  .title {
    color: #3a4f70;
    font-weight: 600;
    font-size: 12px;
  }

  .desc {
    margin: 5px 0;
  }
}

.age {
  border-bottom: 1px dashed #eee;
  padding: 10px 0;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SeoBigData.vue